var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter-list",
    {
      ref: "filterlist",
      attrs: {
        ready: !_vm.loadingOffers && !_vm.loadingFilters,
        title: _vm.translations.filter_header_mobile,
        tabs: _vm.translations.filter_tabs_mobile
      },
      on: {
        tabchange: function(tab) {
          return (_vm.shownFilterTab = tab)
        },
        open: _vm.openChange
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shownFilterTab == 0,
              expression: "shownFilterTab == 0"
            }
          ],
          staticClass: "filter-list__filters"
        },
        [
          _c("offer-counter"),
          _vm._v(" "),
          !_vm.filterError
            ? [
                _c("price-filter", {
                  attrs: { "show-slider": _vm.showPriceFilter }
                }),
                _vm._v(" "),
                _c("checkbox-filter", {
                  attrs: {
                    title: _vm.translations.direct_flight_title,
                    "checkbox-name":
                      _vm.translations.direct_flight_checkbox_title,
                    filterValue: "directFlight"
                  }
                }),
                _vm._v(" "),
                _c("category-filter"),
                _vm._v(" "),
                _vm.categoryFilters.boardTypes
                  ? _c("dropdown-filter", {
                      attrs: {
                        title: _vm.categoryFilters.boardTypes.title,
                        options: _vm.categoryFilters.boardTypes.options,
                        "filter-name":
                          _vm.categoryFilters.boardTypes.filtername,
                        "filter-value":
                          _vm.categoryFilters.boardTypes.filtervalue,
                        search: _vm.categoryFilters.boardTypes.searchable
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.categoryFilters.locations
                  ? _c("dropdown-filter", {
                      attrs: {
                        title: _vm.categoryFilters.locations.title,
                        options: _vm.categoryFilters.locations.options,
                        "filter-name": _vm.categoryFilters.locations.filtername,
                        "filter-value":
                          _vm.categoryFilters.locations.filtervalue,
                        search: _vm.categoryFilters.locations.searchable
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.categoryFilters.roomLocated
                  ? _c("dropdown-filter", {
                      attrs: {
                        title: _vm.categoryFilters.roomLocated.title,
                        options: _vm.categoryFilters.roomLocated.options,
                        "filter-name":
                          _vm.categoryFilters.roomLocated.filtername,
                        "filter-value":
                          _vm.categoryFilters.roomLocated.filtervalue,
                        search: _vm.categoryFilters.roomLocated.searchable
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.categoryFilters.roomTypes
                  ? _c("dropdown-filter", {
                      attrs: {
                        title: _vm.categoryFilters.roomTypes.title,
                        options: _vm.categoryFilters.roomTypes.options,
                        "filter-name": _vm.categoryFilters.roomTypes.filtername,
                        "filter-value":
                          _vm.categoryFilters.roomTypes.filtervalue,
                        search: _vm.categoryFilters.roomTypes.searchable
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("keyword-checkbox", {
                  attrs: {
                    keywordCode: ["transfer-MT", "transfer-OT"],
                    title: _vm.translations.transfer_filter_title,
                    radio: true
                  }
                }),
                _vm._v(" "),
                _c("keyword-checkbox", {
                  attrs: {
                    keywordCode: ["inclusive-ZG"],
                    title: _vm.translations.transport_filter_title
                  }
                }),
                _vm._v(" "),
                _c("keywords", {
                  attrs: {
                    "excluded-keywords": [
                      "transfer-MT",
                      "inclusive-ZG",
                      "transfer-OT"
                    ]
                  },
                  on: {
                    keywordchange: function() {
                      return _vm.$refs.filterlist.$emit("recalculate")
                    }
                  }
                }),
                _vm._v(" "),
                _c("checkbox-filter-list", {
                  attrs: {
                    title: _vm.translations.to_filter_title,
                    options: _vm.tourOperators,
                    "filter-name": "tourOperator"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shownFilterTab === 1,
              expression: "shownFilterTab === 1"
            }
          ],
          staticClass: "filter-list__sort"
        },
        [
          _c("search-sort", {
            on: {
              sortchange: function($event) {
                _vm.closeFilterList()
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-077be94a", { render: render, staticRenderFns: staticRenderFns })
  }
}